import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Share from 'legacy-packages/unit-outline/src/components/ItemAction/Share';
import ItemActionShare from 'legacy-packages/unit-outline/src/components/ItemAction/ItemActionShare';
import NoClassAlert from 'legacy-src/utility/NoClassAlert';
import shareResourceToClass from 'legacy-src/utility/helpers/shareResourceToClass';
import { RESOURCES } from 'chameleon/ui-stack/utilities/copy';
import { compose, withApollo } from 'react-apollo';
import { withRouter } from 'react-router';

const ShareWrapper = (props) => {
  const {
    resource,
    unitNumber,
    classes,
    userData,
    subjectData,
    onClose,
    text,
  } = props;
  const { isStudent } = userData;

  if (isStudent) {
    return null;
  }

  if (!resource) {
    return null;
  }

  const { id: subjectId } = subjectData;
  const { resourceId } = resource;
  const { chosenEducationPeriodCode } = userData;
  const ep = parseInt(chosenEducationPeriodCode, 10);
  const userClasses = get(classes, 'items', []).filter(
    ({ educationPeriod }) => educationPeriod === ep,
  );
  const hasNoClasses = !userClasses.length;

  return (
    <Share
      modalTitle="Share Resource"
      item={resource}
      scope={[
        'units',
        `unit-${unitNumber}`,
        'resources',
        `resource-${resourceId}-subject-${subjectId}`,
      ]}
      items={userClasses}
      onClose={onClose}
      noClassAlert={
        <NoClassAlert
          title=""
          description={RESOURCES.NO_CLASSES_ALERT.DESCRIPTION}
          content={RESOURCES.NO_CLASSES_ALERT.LABEL}
          withMargin={false}
          isNarrow
          className="mt-0"
          descriptionClassName="m-4.6 text-14 font-medium text-gray-700"
          contentClassName="m-6"
        />
      }
      hasNoClasses={hasNoClasses}
      userData={userData}
      save={shareResourceToClass}
    >
      <ItemActionShare text={text} className="share-icon" />
    </Share>
  );
};

ShareWrapper.displayName = 'ShareWrapper';

ShareWrapper.propTypes = {
  resource: PropTypes.object.isRequired,
  unitNumber: PropTypes.string.isRequired,
};

const mapStateToProps = ({ classes, userData, subject }) => ({
  classes,
  userData,
  subjectData: subject.data || {},
});

export default compose(
  withApollo,
  withRouter,
  connect(mapStateToProps),
)(ShareWrapper);
